import { settingsSvcApi } from '@ctct/infrastructure-layer';

import { FeatureSettingSchema } from './schemas';
import { zodService } from '../ZodService';

class FeatureSettings {
  public async getEnableAmexIrAffiliate() {
    const response = await settingsSvcApi.getFeatureSetting('enable_amex_ir_affiliate');

    const data = zodService.safeParse(FeatureSettingSchema, response.data);

    return data.enabled;
  }

  public async getTrialerPayflowFlag() {
    const response = await settingsSvcApi.getFeatureSetting('enable_unified_trialer_flow');

    const data = zodService.safeParse(FeatureSettingSchema, response.data);

    return data.enabled;
  }

  public async getAdvancedIbpPreview() {
    return this.getIsFlagEnabled('enable_advanced_preview_redirect', 'em-ui');
  }

  private async getIsFlagEnabled(flagName: string, applicationId = 'myaccount') {
    const response = await settingsSvcApi.getFeatureSetting(flagName, applicationId);

    const data = zodService.safeParse(FeatureSettingSchema, response.data);

    return data.enabled;
  }
}

export const featureSettings = new FeatureSettings();
